import { useCallback, useMemo, useState } from "react";
import { useVisibility } from "./use-visibility";

export const useProductLightbox = ({
	products,
	onProductChange = undefined,
}) => {
	const {
		visible,
		show: showProductLightbox,
		hide: hideProductLightbox,
	} = useVisibility();

	// pozor na, při přímé mutaci je potřeba zavolat onProductChange
	const [currentProductIndex, __setCurrentProductIndex] = useState(0);

	const hasPrevious = currentProductIndex > 0;
	const hasNext = currentProductIndex < products.length - 1;

	const moveNext = useCallback(() => {
		__setCurrentProductIndex((prev) => {
			let newIndex = prev + 1;

			if (newIndex >= products.length) {
				newIndex = products.length - 1;
			}

			if (onProductChange) {
				onProductChange(newIndex);
			}

			return newIndex;
		});
	}, [onProductChange]);

	const movePrevious = useCallback(() => {
		__setCurrentProductIndex((prev) => {
			let newIndex = prev - 1;

			if (newIndex < 0) {
				newIndex = 0;
			}

			if (onProductChange) {
				onProductChange(newIndex);
			}

			return newIndex;
		});
	}, [onProductChange]);

	const showProductLightboxAtProduct = useCallback(
		(productUid) => {
			const index = products.findIndex((product) => product.uid === productUid);

			if (index === -1) {
				console.error(
					"[INTERACTIVE PRODUCTS] No product with uid",
					productUid,
					"inside",
					products
				);
				return;
			}

			if (onProductChange) {
				onProductChange(index);
			}

			__setCurrentProductIndex(index);
			showProductLightbox();
		},
		[onProductChange, products]
	);

	const controls = useMemo(() => {
		return {
			showProductLightbox,
			showProductLightboxAtProduct,
			hideProductLightbox,
		};
	}, [showProductLightbox, hideProductLightbox, showProductLightboxAtProduct]);

	return {
		controls,
		visible,
		currentProductIndex,

		hasNext,
		hasPrevious,
		moveNext,
		movePrevious,
	};
};
